import { createPortal } from 'react-dom';
import React from 'react';

interface PortalProps {
  children: React.ReactNode;
  containerId?: string; // Optional – z. B. "menu-portal-root"
}

const Portal: React.FC<PortalProps> = ({ children, containerId = 'menu-portal-root' }) => {
  const container = document.getElementById(containerId);
  if (!container) return null;
  return createPortal(children, container);
};

export default Portal;